import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderChefInIpswitchResources extends ResourceItemHtmlProvider {
  constructor(filterServices) {
    super(filterServices);
    this.cssClasses = {

    },
      this.defaultResourceData = [
        {
          imagePath: "/images/cheflibraries/resources/data_sheet-new.svg",
          cta: "Download Now",
          id: "eeb3c6b5-1f50-4737-a2f3-717e59683ec2"
        },
        {
          imagePath: "/images/cheflibraries/resources/webinar-new.svg",
          cta: "Watch the Webinar",
          id: "d743233e-7255-424b-ad23-32b674f698db"
        },
        {
          imagePath: "/images/cheflibraries/resources/whitepaper-new.svg",
          cta: "Download Now",
          id: "fd8805fa-9232-4470-892e-e2e2bb263842"
        },
        {
          imagePath: "/images/cheflibraries/resources/customer_story-new.svg",
          cta: "View the Customer Story",
          id: "35e120fe-546e-4900-a6c5-324a1ebce270"
        },
        {
          imagePath: null,
          cta: "Watch Video",
          id: "9d8ba3b3-b596-4e59-ac3a-a7df21d642fb"
        },
        {
          imagePath: "/images/cheflibraries/resources/video-new.svg",
          cta: "Watch Video",
          id: "c5dbf402-5020-4c9f-a6e5-80fbc168e2e8"
        },
        {
          imagePath: null,
          cta: "Download Now",
          id: "63a9b7cc-0814-4876-8a8f-d77bd1451ddd"
        },
        {
          imagePath: "/images/cheflibraries/resources/generic-new.svg",
          cta: "Download Now",
          id: "5c0179a1-80e8-4ef2-8f71-8fb79172e700"
        },
        {
          imagePath: "/images/cheflibraries/resources/analyst-report.svg",
          cta: "Download the Report",
          id: "fba60918-8c88-4d01-afc9-63a9c113f644"
        },
        {
          imagePath: "/images/cheflibraries/resources/glossary.svg",
          cta: "Learn more",
          id: "4e164743-8057-47fc-aedf-70893c4361e2"
        },
        {
          // Reference architecture content type
          imagePath: "/images/chefcommunitylibraries/resources/reference-architecture.svg",
          cta: "Learn more",
          id: "0206c1cc-b28a-47bb-8f15-e85fc7e10872"
        },
        {
          // Patterns
          imagePath: "/images/chefcommunitylibraries/resources/patterns.svg",
          cta: "Learn more",
          id: "b3ef6d9d-3592-4a0d-8a29-53d8966ab9cc"
        },
        {
          // Best Practice
          imagePath: "/images/chefcommunitylibraries/resources/best-practices.svg",
          cta: "Learn more",
          id: "70ae4793-8040-4c66-8bdf-0a7f4e81ede7"
        },
        {
          // Solutions
          imagePath: "/images/chefcommunitylibraries/resources/solutions.svg",
          cta: "Learn more",
          id: "fc755d25-6e7b-48fc-8fa9-3fc439cc4994"
        },
        {
          // Guidance
          imagePath: "/images/chefcommunitylibraries/resources/guidance.svg",
          cta: "Learn more",
          id: "1dcb323e-a053-4c73-88a9-d2e55387f435"
        }
      ]
  }

  getItemHtml(item, relatedMedia) {     
    let fileData = null;
    let isWebinar = item.resourceCategory[0].Id == "d743233e-7255-424b-ad23-32b674f698db";
    if (item.resourceCategory[0].Id != "35e120fe-546e-4900-a6c5-324a1ebce270") {
      fileData = item.NotGated && item.File && item.File.length > 0 ? item.File[0] : null
    }  
    const { UrlName: resourcePath, CTAUrl } = item;
    const CTATextFallback = this.defaultResourceData.find(ct => ct.id === item.resourceCategory[0].Id)?.cta;    
    const imagePath = item.ListImage && item.ListImage.length > 0 ? item.ListImage[0].Url : this.defaultResourceData.find(ct => ct.id === item.resourceCategory[0].Id)?.imagePath;
    const imageFallback = '/images/cheflibraries/resources/generic-new.svg';
    const startDateISO = (new Date(item.StartDate)).toISOString();
    const label = `<span class="Label -wa -mb1 -mt1  ${item.IsUpcomming ? "-tint-lightred" : "-tint-lightblue"}">${item.IsUpcomming ? "Upcoming" : "OnDemand"}</span>`;
    const featuredLabel = `${item.IsFeatured ? "<span class='Label -wa -mb1 -mt1 -tint-lightyellow'>Featured</span>": ''}`;
    const summaryParagraph = `<p class="-fs16 -lines-3 -hyphenate">${this.encodeHtml(item.Summary)}</p>`;
    const timeElement =  item.IsUpcomming ? `<time class="h6 -fs12 -c-darkgrey -mb2" datetime="${startDateISO}">${this.getDate(item.StartDate)}</time>`: '';
    const pageUrl = super.getResourceUrl(item.contenttypes[0]);
    let resourceUrl;

    if (CTAUrl) {
       resourceUrl = CTAUrl;
    }
    else {
       resourceUrl = `${pageUrl}/${resourcePath}`;
    }
    
    const target = fileData != null ?  `target="_blank"` : "";
    const html = `
        <div class="col-3 -xl-half -l-third -m-half -s-full">
            <div class="Card -h-scale">
                <img src="${imagePath || imageFallback}" alt="${item.resourceCategory[0].Title} Thumbnail" />
                <span class='-pa -ml1'>
                ${featuredLabel} ${isWebinar ? label : ''}
                </span>
                <div class="-mt0">
                <p class="-ttu -fs12 -c-darkgrey -ff-title -s-mb1">${item.resourceCategory[0].Title}</p>
                    <h5 class="-mb3">${this.encodeHtml(item.Title)}</h5>
                    ${isWebinar ? timeElement : ''}
                    ${item.Summary ? summaryParagraph : ''}
                    <a href="${fileData == null ? resourceUrl : fileData.Url}" ${target} class="HoverBox -mta -i-next">${this.encodeHtml(item.CTAText) || CTATextFallback}</a>
                </div>
            </div>
        </div>
    `;

    return html;
  } 

  getDate(utcDate){
    let date = new Date(utcDate);
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  }
}
